"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Image;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactUseIdHook = require("react-use-id-hook");
var _util = require("../util");
var _excluded = ["alt", "longAlt", "style", "photoCredit"],
  _excluded2 = ["maxWidth", "height", "maxHeight"];
function Image(_ref) {
  var _props$alignment2;
  var alt = _ref.alt,
    longAlt = _ref.longAlt,
    style = _ref.style,
    photoCredit = _ref.photoCredit,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  if (alt === undefined && !props.suppressErrors) {
    throw new Error("Images must have prop 'alt' specified.");
  }
  var id = (0, _reactUseIdHook.useId)();
  var _ref2 = style || {},
    maxWidth = _ref2.maxWidth,
    height = _ref2.height,
    maxHeight = _ref2.maxHeight,
    stylerest = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  if (longAlt || photoCredit) {
    var _props$alignment;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "bdg-image",
      style: {
        display: props.alignment ? "flex" : undefined,
        justifyContent: (_props$alignment = props.alignment) !== null && _props$alignment !== void 0 ? _props$alignment : undefined
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        maxWidth: maxWidth || "100%"
      }
    }, /*#__PURE__*/_react.default.createElement("img", Object.assign({
      alt: alt,
      style: (0, _objectSpread2.default)({
        maxWidth: '100%',
        height: height,
        maxHeight: maxHeight
      }, stylerest),
      "aria-describedby": longAlt ? "desc-".concat(id) : undefined
    }, props)), (0, _util.ContentToString)(photoCredit) && /*#__PURE__*/_react.default.createElement("span", {
      className: "photo-credit"
    }, photoCredit)), longAlt && /*#__PURE__*/_react.default.createElement("p", {
      id: "desc-".concat(id),
      className: "sr-only"
    }, longAlt));
  }
  return /*#__PURE__*/_react.default.createElement("img", Object.assign({
    alt: alt,
    style: (0, _objectSpread2.default)({
      display: props.alignment ? "flex" : undefined,
      justifyContent: (_props$alignment2 = props.alignment) !== null && _props$alignment2 !== void 0 ? _props$alignment2 : undefined,
      maxWidth: maxWidth || "100%"
    }, stylerest)
  }, props));
}